export default __webpack_public_path__ + "img/2d48fd1a3aa14d4e8b586a56c3f29629.png";